import { BACKSPACE } from 'constants/keys';

const INPUT_TYPES = ['EMAIL', 'TEXT', 'PASSWORD', 'FILE'];

// prevent backspace triggering back button
export const preventBackspace = (event: KeyboardEvent) => {
  if (event.keyCode !== BACKSPACE) {
    return;
  }

  const element = (event.srcElement || event.target) as HTMLInputElement | HTMLTextAreaElement | null;
  if (!element || !element.tagName) return;

  const tag = element.tagName.toUpperCase();
  const type = (element.type || '').toUpperCase();
  let prevent = true;
  if ((tag === 'INPUT' && INPUT_TYPES.includes(type)) || tag === 'TEXTAREA') {
    prevent = element.readOnly || element.disabled;
  }

  if (prevent) {
    event.preventDefault();
  }
};

export const emitNativeEvent = (name: string) => {
  const event = document.createEvent('Event');
  event.initEvent(name, true, true);
  document.dispatchEvent(event);
};

export const triggerMouseEvent = (element = document.body, eventName: string, simulated: string | boolean = true) => {
  const event = document.createEvent('MouseEvents');
  event.initMouseEvent(
    eventName,
    true, true, window,
    1, 0, 0, 0, 0,
    false, false, false, false,
    0, null,
  );

  (event as any).simulated = simulated;
  element.dispatchEvent(event);
};

export const triggerMouseUp = (element = document.body, simulated: string | boolean = true) =>
  triggerMouseEvent(element, 'mouseup', simulated);
